import { Button, ButtonShortcut } from "@/components/ui/button";
import { useProjectLimitsContext } from "./ProjectLimitsContext";
import { useCallback } from "react";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { useCheckIsProjectLocked } from "../../hooks/useCheckIsProjectLocked";
import { useProjectId } from "../../hooks/useProjectId";
import { useTranslation } from "react-i18next";
import { PlusIcon } from "lucide-react";
import ModKeyChar from "@/components/ModKeyChar";
import { ButtonProps } from "@/components/ui/button";

export const ProjectLimitUpsertButton = (props: ButtonProps) => {
  const { t } = useTranslation();
  const projectId = useProjectId();
  const { setIsAddLimitsDialogOpen } = useProjectLimitsContext();
  const { can_update } = useModulePermissions();
  const isProjectLocked = useCheckIsProjectLocked(projectId);

  const onAddLimits = useCallback(() => {
    setIsAddLimitsDialogOpen(true);
  }, [setIsAddLimitsDialogOpen]);

  return (
    <Button
      variant="secondary"
      size="sm"
      {...props}
      onClick={onAddLimits}
      disabled={!can_update || isProjectLocked}
    >
      <PlusIcon className="w-4 h-4" />
      {t("projectLimits.actions.upsertLimits")}
      <ButtonShortcut>
        <ModKeyChar />A
      </ButtonShortcut>
    </Button>
  );
};
